import React, { createContext, useEffect, useState, useContext } from 'react'
import {
  Button,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text
} from '@stars-ecom/shared-atoms-ui'
import { WebsiteContext } from '../context'

const WebsiteRestrictorContext = createContext({})

const emiWebsite = {
  "1001": "https://www.teleshopping.fr",
  "1006": "https://www.m6boutique.com"
};
const windowGlobal = typeof window !== 'undefined' && window

const PopinRestritAccess = ({ isOpen, websiteCode, setWebsiteCode }) => {
  const [ inputValue, setInputValue ] = useState(websiteCode);
  const [ errorCode, setErrorCode ] = useState(false);
  const websiteContext = useContext(WebsiteContext)

  const handleChange = (e) => {
    const { name, value } = e.target;
    if ( name === 'websiteCode' ) setInputValue(value);
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputValue !== process.env.GATSBY_API_CHANNEL_HAS_CODE)
      return setErrorCode(true);
    else {
      setErrorCode(false);
      setWebsiteCode(inputValue);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => { console.error("Restrict popin can't be closed") }}
      size='xl'
      scrollBehavior='inside'
      className="chakra-modal__restricted-popin"
      isCentered={!websiteContext.isMobile}
    >
      <ModalOverlay backdropFilter="blur(10px)" />
      <ModalContent>
        <ModalBody p="0">
          <Flex
            w={{ base: '100%' }}
            flexDirection='column'
            p={{ base: '20px' }}
          >
            <Text fontWeight="900" fontSize="20px" mb="16px" fontFamily="PT Sans">
              {websiteContext?.title}
            </Text>
            <Text fontSize="15px" mb="10px" fontFamily="PT Sans">
              Pour accéder aux offres du Catalogue {websiteContext?.title}, veuillez saisir le code d'accès que vous avez reçu par mail.
            </Text>
            <form
              onSubmit={handleSubmit}
              style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <Input
                value={inputValue}
                pr="2"
                mb="2"
                name='websiteCode'
                placeholder="Code d'accès"
                backgroundColor="white"
                borderRadius="0px"
                borderColor={errorCode ? 'red' : 'unset'}
                _focus={{ borderColor: '#c1c1c1' }}
                border={errorCode ? '2px solid red' : '1px solid #c1c1c1'}
                fontSize="14px"
                onChange={handleChange}
                autoComplete='new-password'
              />
              {errorCode && (
                <Text color="red" fontSize="12px" lineHeight="12px" mb="-12px">
                  Votre code d'accès est invalide
                </Text>
              )}
              <Flex direction="column" align="center" flex="1" justify="flex-end">
                <Button
                  type="submit"
                  backgroundColor={websiteContext.mainColor}
                  fontFamily="PT Sans"
                  color="white"
                  fontSize="16px"
                  fontWeight="400"
                  letterSpacing="0.5px"
                  textTransform="uppercase"
                  borderRadius="0px"
                  _hover={{ bg: websiteContext.darkColor }}
                  isFullWidth={websiteContext.isMobile}>
                  Valider
                </Button>
              </Flex>
            </form>
            <Text fontSize="15px" m="10px" fontFamily="PT Sans">
              Je n'ai pas reçu le code d'accès au site Catalogue {websiteContext?.title} et je souhaite aller directement sur{' '}
              <a 
                target="_blank"
                style={{ color: 'blue', marginTop: '12px', marginBottom: '12px' }}
                rel="noreferrer"
                href={emiWebsite[websiteContext?.customFields?.companyCode]}
              >
                {emiWebsite[websiteContext?.customFields?.companyCode]?.replace('https://', '').replace('http://', '')}
              </a>
            </Text>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

const WebsiteRestrictorContextProvider = ({ children }) => {
  const [ websiteCode, setWebsiteCode ] = useState("");
  const [ popinOpen, setPopin ] = useState(false);

  const openModal = () => setPopin(!popinOpen);

  useEffect(async () => {
    // split on '; ' because all cookies is separated by '; ' and we don't need it
    const parsedCookie = windowGlobal.document.cookie.split('; ');
    let channelHasCodeCookie = parsedCookie.find(c => c.includes('channelHasCode'));
    // remove keys of cookies to compare value only
    if (!!channelHasCodeCookie) channelHasCodeCookie = channelHasCodeCookie.replace('channelHasCode=', '');

    if (
      process.env.GATSBY_API_CHANNEL_HAS_CODE &&
      process.env.GATSBY_API_CHANNEL_HAS_CODE.length > 2 &&
      channelHasCodeCookie !== process.env.GATSBY_API_CHANNEL_HAS_CODE
    ) {
      // websiteCode in state is not equal to channel code, popin is closed, and cookie is undefined or not equal => open popin
      if (
        websiteCode !== process.env.GATSBY_API_CHANNEL_HAS_CODE &&
        !popinOpen &&
        (!channelHasCodeCookie || channelHasCodeCookie !== process.env.GATSBY_API_CHANNEL_HAS_CODE)
      ) {
        openModal();
      }
      // websiteCode in state is equal to channel code => close popin and create cookie
      if (websiteCode === process.env.GATSBY_API_CHANNEL_HAS_CODE && popinOpen) {
        openModal();
        const expireAt = new Date();
        expireAt.setDate(expireAt.getDate() + 90); // 90 days of validity
        window.document.cookie = `channelHasCode=${websiteCode}; expires=${expireAt.toUTCString()}"`;
      }
    }
  }, [ websiteCode ]);

  return (
    <WebsiteRestrictorContext.Provider value={{ websiteCode }}>
      {children}
      { !!popinOpen && <PopinRestritAccess 
        isOpen={popinOpen}
        websiteCode={websiteCode}
        setWebsiteCode={setWebsiteCode}
        close={ openModal } />
      }
    </WebsiteRestrictorContext.Provider>
  )
}
  
WebsiteRestrictorContextProvider.displayName = 'WebsiteRestrictorContextProvider'
  
export { WebsiteRestrictorContextProvider, WebsiteRestrictorContext }